import React, { memo } from 'react';
import { Text } from '@Sage/hoi-poi-ui';

import { getLiteralWithParametersHtml } from 'utils/getLiteral';

const TitleContentDetail = memo(({ label, params }) => {
    if (!label) return null;

    const content =
        params?.length > 0
            ? getLiteralWithParametersHtml(label, params, (text) =>
                  text?.trim() ? <strong>{text}</strong> : null,
              )
            : label;

    return <Text type="h6">{content}</Text>;
});

export default TitleContentDetail;
